module.exports = __webpack_public_path__ + "images/social-icons/linkedin-icon.fe5be7b786ae582c96f0.svg";